import { useCallback } from 'react';

import { useElements } from '@stripe/react-stripe-js';

import { useCustomerSession } from '@order/integrations-stripe';

/**
 * If the payment method list is updated from outside (e.g. from the customer sheet), the payment element itself needs to be updated.
 */
export const useUpdatePaymentElementOnChange = (props: Props) => {
  const { onPaymentMethodChanged } = props;

  const elements = useElements();

  const { fetchCustomerSessionSecret } = useCustomerSession();

  return useCallback(async () => {
    onPaymentMethodChanged();

    if (elements) {
      try {
        const customerSessionClientSecret = await fetchCustomerSessionSecret();
        await elements.update({ customerSessionClientSecret });
      } catch {}
    }
  }, [onPaymentMethodChanged, elements, fetchCustomerSessionSecret]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onPaymentMethodChanged: () => void;
};
